import { TranslateResult } from "vue-i18n";
import i18n from '@/typescript/servicos/i18n/i18n.servico';
import {
  Categorias,
  CategoriaDataReferencia,
  CategoriaEmpregadoEEmpregador,
  CategoriaValor,
  Alinhamento
} from "./dominio/e02.enum";

interface IObjetoSeletor<T> {
  id: T;
  name: TranslateResult;
}

interface IConfiguracaoSeletor<T> {
  loaded: IObjetoSeletor<T>[];
  selected: IObjetoSeletor<T> | null;
}

type ICategoriaCodigo = IConfiguracaoSeletor<Categorias>;
type ICategoriaDataReferencia = IConfiguracaoSeletor<CategoriaDataReferencia>;
type ICategoriaEmpregadoEEmpregador = IConfiguracaoSeletor<CategoriaEmpregadoEEmpregador>;
type ICategoriaValor = IConfiguracaoSeletor<CategoriaValor>;
type IConfiguracaoAlinhamento = IConfiguracaoSeletor<Alinhamento>;


export const configuracaoCategoriaCodigo: ICategoriaCodigo = {
  loaded: [
    { id: Categorias.Empregado, name: i18n.t('layoutE02.layout.labels.empregado') },
    { id: Categorias.Empregador, name: i18n.t('layoutE02.layout.labels.empregador') },
    { id: Categorias.Fixo, name: i18n.t('layoutE02.layout.labels.fixo') },
    { id: Categorias.Verba, name: i18n.t('layoutE02.layout.labels.verba') },
    { id: Categorias.Valor, name: i18n.t('layoutE02.layout.labels.valor') },
    { id: Categorias.DataDeReferencia, name: i18n.t('layoutE02.layout.labels.dataDeReferencia') },
    { id: Categorias.Sequencial, name: i18n.t('layoutE02.layout.labels.sequencial') },
    { id: Categorias.TipoDaVerba, name: i18n.t('layoutE02.layout.labels.tipoDaVerba.titulo') },
    { id: Categorias.UnidadeDaVerba, name: i18n.t('layoutE02.layout.labels.unidadeDaVerba.titulo') },
    { id: Categorias.NomeDoEvento, name: i18n.t('layoutE02.layout.labels.nomeDoEvento') },
    { id: Categorias.CampoCustomizavelPorEmpregado, name: i18n.t('layoutE02.layout.labels.campoCustomizavelPorEmpregado') },
  ],
  selected: null
};

export const configuracaoCategoriaDataReferencia: ICategoriaDataReferencia = {
  loaded: [
    { id: CategoriaDataReferencia.AAAAMMDD, name: 'aaaammdd' },
    { id: CategoriaDataReferencia.AAAA_MM_DD_Barra, name: 'aaaa/mm/dd' },
    { id: CategoriaDataReferencia.AAAA_MM_DD_Hifen, name: 'aaaa-mm-dd' },
    { id: CategoriaDataReferencia.DD_MM_YYYY_Ponto, name: 'dd.mm.aaaa' },
    { id: CategoriaDataReferencia.DD_MM_YYYY_Barra, name: 'dd/mm/aaaa' },
    { id: CategoriaDataReferencia.DD_MM_YYYY_Hifen, name: 'dd-mm-aaaa' },
    { id: CategoriaDataReferencia.MMAAAA, name: 'mmaaaa' },
    { id: CategoriaDataReferencia.MMAAAA_Hifen, name: 'mm-aaaa' },
    { id: CategoriaDataReferencia.MMAAAA_Barra, name: 'mm/aaaa' },
    { id: CategoriaDataReferencia.AAAAMM, name: 'aaaamm' },
    { id: CategoriaDataReferencia.DDMMAA, name: 'ddmmaa' },
  ],
  selected: null
}

export const configuracaoCategoriaEmpregado: ICategoriaEmpregadoEEmpregador = {
  loaded: [
    { id: CategoriaEmpregadoEEmpregador.Nome, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.nomeEmpregado') },
    { id: CategoriaEmpregadoEEmpregador.Codigo, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.codigoEmpregado') },
    { id: CategoriaEmpregadoEEmpregador.CPF, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.cpf') },
    { id: CategoriaEmpregadoEEmpregador.RG, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.rg') },
    { id: CategoriaEmpregadoEEmpregador.PIS, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.pis') },
    { id: CategoriaEmpregadoEEmpregador.CodigoLocalTrabalho, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.codigoLocalTrabalho') },
    { id: CategoriaEmpregadoEEmpregador.NomeLocalTrabalho, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.nomeLocalTrabalho') },
  ],
  selected: null
}

export const configuracaoCategoriaEmpregador: ICategoriaEmpregadoEEmpregador = {
  loaded: [
    { id: CategoriaEmpregadoEEmpregador.Empregador_Nome, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.nomeEmpregador') },
    { id: CategoriaEmpregadoEEmpregador.Empregador_Codigo, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.codigoEmpregador') },
    { id: CategoriaEmpregadoEEmpregador.Empregador_NomeComercial, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.nomeComercialEmpregador') },
    { id: CategoriaEmpregadoEEmpregador.Empregador_CPF, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.cpfEmpregador') },
    { id: CategoriaEmpregadoEEmpregador.Empregador_CNPJ, name: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.cnpjEmpregador') },
  ],
  selected: null
}

export const configuracaoCategoriaValor: ICategoriaValor = {
  loaded: [
    { id: CategoriaValor.Decimal, name: i18n.t('layoutE02.layout.labels.valorDaVerba.decimal') },
    { id: CategoriaValor.HorasEMinutos, name: i18n.t('layoutE02.layout.labels.valorDaVerba.horasEMinutos') },
    { id: CategoriaValor.Inteiro, name: i18n.t('layoutE02.layout.labels.valorDaVerba.inteiro') },
    { id: CategoriaValor.Minutos, name: i18n.t('layoutE02.layout.labels.valorDaVerba.minutos') },
  ],
  selected: null
}

export const configuracaoAlinhamento: IConfiguracaoAlinhamento = {
  loaded: [
    { id: Alinhamento.Esquerda, name: i18n.t('layoutE02.layout.labels.alinhamento.esquerda') },
    { id: Alinhamento.Direita, name: i18n.t('layoutE02.layout.labels.alinhamento.direita') },
  ],
  selected: null
};

export const titulosFormatados: Record<Categorias, TranslateResult> = {
  [Categorias.Empregado]: i18n.t('layoutE02.layout.labels.empregado'),
  [Categorias.Empregador]: i18n.t('layoutE02.layout.labels.empregador'),
  [Categorias.Fixo]: i18n.t('layoutE02.layout.labels.fixo'),
  [Categorias.Verba]: i18n.t('layoutE02.layout.labels.verba'),
  [Categorias.DataDeReferencia]: i18n.t('layoutE02.layout.labels.dataDeReferencia'),
  [Categorias.Valor]: i18n.t('layoutE02.layout.labels.valor'),
  [Categorias.Sequencial]: i18n.t('layoutE02.layout.labels.sequencial'),
  [Categorias.TipoDaVerba]: i18n.t('layoutE02.layout.labels.tipoDaVerba.titulo'),
  [Categorias.UnidadeDaVerba]: i18n.t('layoutE02.layout.labels.unidadeDaVerba.titulo'),
  [Categorias.NomeDoEvento]: i18n.t('layoutE02.layout.labels.nomeDoEvento'),
  [Categorias.CampoCustomizavelPorEmpregado]: i18n.t('layoutE02.layout.labels.campoCustomizavelPorEmpregado'),
};

export const titulosSubCampoEmpregadoEEmpregador: Partial<Record<CategoriaEmpregadoEEmpregador, TranslateResult>> = {
  [CategoriaEmpregadoEEmpregador.Nome]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.nome'),
  [CategoriaEmpregadoEEmpregador.Codigo]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.codigo'),
  [CategoriaEmpregadoEEmpregador.CPF]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.cpf'),
  [CategoriaEmpregadoEEmpregador.RG]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.rg'),
  [CategoriaEmpregadoEEmpregador.PIS]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.pis'),
  [CategoriaEmpregadoEEmpregador.CodigoLocalTrabalho]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.codigoLocalTrabalho'),
  [CategoriaEmpregadoEEmpregador.NomeLocalTrabalho]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.nomeLocalTrabalho'),
  [CategoriaEmpregadoEEmpregador.Empregador_Nome]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.nomeEmpregador'),
  [CategoriaEmpregadoEEmpregador.Empregador_Codigo]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.codigoEmpregador'),
  [CategoriaEmpregadoEEmpregador.Empregador_NomeComercial]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.nomeComercialEmpregador'),
  [CategoriaEmpregadoEEmpregador.Empregador_CPF]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.cpfEmpregador'),
  [CategoriaEmpregadoEEmpregador.Empregador_CNPJ]: i18n.t('layoutE02.layout.labels.empregadoEEmpregador.cnpjEmpregador'),
};

// cria uma constante de datas formatadas, aproveitando a configuração de categoria de data de referência
export const dataFormatada = configuracaoCategoriaDataReferencia.loaded.reduce((dataFormatada, item) => {
  dataFormatada[item.id] = item.name as string
  return dataFormatada
}, {} as Record<CategoriaDataReferencia, string>)
